import { render, staticRenderFns } from "./CategorySelection.vue?vue&type=template&id=09f790cf"
import script from "./CategorySelection.vue?vue&type=script&lang=js"
export * from "./CategorySelection.vue?vue&type=script&lang=js"
import style0 from "./CategorySelection.vue?vue&type=style&index=0&id=09f790cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports